/**
 * Helpers de formatação financeira e temporal.
 *
 * REGRA DE OURO: valores monetários SEMPRE em centavos (integer).
 * Toda função aqui aceita centavos e retorna string formatada.
 */

const BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const BRL_COMPACT = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  maximumFractionDigits: 1,
});

const PERCENT = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  maximumFractionDigits: 1,
});

const DATE_FULL = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATE_SHORT = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
});

const TIME = new Intl.DateTimeFormat('pt-BR', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatBRL(cents: number): string {
  return BRL.format(cents / 100);
}

export function formatBRLCompact(cents: number): string {
  return BRL_COMPACT.format(cents / 100);
}

export function formatPercent(value: number): string {
  return PERCENT.format(value);
}

export function formatDate(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return DATE_FULL.format(date);
}

export function formatDateShort(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return DATE_SHORT.format(date);
}

export function formatTime(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return TIME.format(date);
}

export function formatDelta(current: number, previous: number): {
  pct: number;
  label: string;
  direction: 'up' | 'down' | 'flat';
} {
  if (previous === 0) {
    return { pct: 0, label: '—', direction: 'flat' };
  }
  const pct = (current - previous) / Math.abs(previous);
  const direction = pct > 0.001 ? 'up' : pct < -0.001 ? 'down' : 'flat';
  const sign = pct > 0 ? '+' : '';
  return { pct, label: `${sign}${formatPercent(pct)}`, direction };
}

/**
 * Formata número de telefone brasileiro de forma defensiva (input pode ser sujo).
 * Útil ao exibir dados do comprador ML.
 */
export function formatPhoneBR(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return raw;
}
